
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/payments",
      function () {
        return require("private-next-pages/[lang]/payments.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/payments"])
      });
    }
  